<template>
    <div class="my-plan">
        <div class="my-plan__screen" v-if="currentScreen === 'welcome'">
            <div class="my-plan__video__container" v-if="page.welcome.video_id">
                <div class="my-plan__video">
                    <iframe v-bind:src="'https://player.vimeo.com/video/' + page.welcome.video_id + '?autoplay=0&loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media'" allowfullscreen allowtransparency></iframe>
                </div>
            </div>

            <h2 class="my-plan__heading is-wide" v-html="page.welcome.welcome_heading"></h2>
            <h3 class="my-plan__subheading is-wide"
                v-html="page.welcome.welcome_subheading"
                v-if="page.welcome.welcome_subheading !== ''"
            ></h3>

            <div class="my-plan__btns is-wide">
                <a class="my-plan__btn is-mauve"
                   v-html="page.welcome.welcome_button_label"
                   v-on:click="gotoScreen('question', 0)"
                ></a>

                <a class="my-plan__link-btn" v-on:click="skipQuestions">Or skip</a>
            </div>
        </div>

        <div class="my-plan__screen"
             v-for="(question, key) in page.questions"
             v-if="page.questions.length > 0 && currentScreen === 'question' && currentQuestion === key"
        >

            <h2 class="my-plan__heading" v-html="question.question_heading"></h2>
            <h3 class="my-plan__subheading" v-html="question.question"></h3>

            <div class="my-plan__answers">
                <a class="my-plan__answer"
                   v-bind:class="{ 'is-selected' : answerSequence[key] === String.fromCharCode(letter + 65) }"
                   v-for="(answer, letter) in question.answers"
                   v-html="answer"
                   v-on:click="setAnswer(key, letter)"
                ></a>
            </div>

            <div class="my-plan__btns">
                <a class="my-plan__nav-btn"
                   v-on:click="
                    previousQuestion(key) !== null
                    ? gotoScreen('question', previousQuestion(key), true)
                    : gotoScreen('welcome', null, true)
               "
                >
                    &laquo; Back
                </a>

                <a class="my-plan__nav-btn"
                   v-bind:class="{ 'is-disabled' : answerSequenceLength <= key }"
                   v-on:click="
                        nextQuestion(key) !== null
                        ? gotoScreen('question', nextQuestion(key))
                        : gotoScreen('end')
                   "
                >
                    Next &raquo;
                </a>
            </div>

            <div class="my-plan__progress__container">
                <div class="my-plan__progress__number">
                    <span>{{ (currentQuestion + 1).toString().padStart(2, 0) }}</span> / {{ totalQuestions.toString().padStart(2, 0) }}
                </div>
                <div class="my-plan__progress">
                    <div class="my-plan__progress__bar" v-bind:style="'width: ' + completed + '%'"></div>
                </div>
            </div>
        </div>

        <div class="my-plan__screen" v-if="result && currentScreen === 'end'">
            <h2 class="my-plan__heading" v-html="page.end.end_heading"></h2>
            <h3 class="my-plan__subheading"
                v-html="result.answer_text"
                v-if="result.answer_text !== ''"
            ></h3>

            <div class="my-plan__text" v-html="page.end.text_bottom" v-if="page.end.text_bottom !== ''"></div>

            <div class="my-plan__btns">
                <a class="my-plan__nav-btn"
                   v-on:click="
                    previousQuestion(99) !== null
                    ? gotoScreen('question', previousQuestion(99), true)
                    : gotoScreen('welcome', null, true)
               "
                >
                    &laquo; Back
                </a>

                <a class="my-plan__btn is-mauve"
                   v-html="page.end.end_button_label"
                   v-on:click.prevent="gotoScreen('my-plan')"
                ></a>
            </div>
        </div>

        <div class="my-plan__screen my-plan__screen--my-plan"
             v-if="result && currentScreen === 'my-plan'"
        >
            <div class="my-plan__overview">
                <a class="my-plan__nav-btn" v-on:click="refreshPlan">&laquo; Back</a>
                <h2 class="my-plan__heading is-large" v-html="page.my_plan.my_plan_heading"></h2>
                <h3 class="my-plan__subheading"
                    v-html="page.my_plan.my_plan_subheading"
                    v-if="page.my_plan.my_plan_subheading !== ''"
                ></h3>

                <a class="my-plan__export-link" href="/my-plan/export" v-html="page.my_plan.export_link_text"></a>
                <a class="my-plan__refresh-link" v-html="page.my_plan.refresh_link_text" v-on:click="refreshPlan"></a>

                <div class="my-plan__text is-hidden-mobile is-hidden-tablet-only"
                     v-html="page.my_plan.text"
                     v-if="page.my_plan.text !== ''"
                ></div>

                <a class="my-plan__btn is-hidden-mobile is-hidden-tablet-only is-left-aligned"
                   v-bind:href="page.my_plan.my_plan_button_link"
                   v-html="page.my_plan.my_plan_button_label"
                ></a>
            </div>

            <div class="my-plan__boxes__wrapper"
                 v-bind:class="{ 'has-fade' : !boxControl.isDisabled.prev }"
                 v-on:mousedown="moveBoxesStart"
                 v-on:mouseup="moveBoxesFinish"
                 v-on:touchstart="moveBoxesStart"
                 v-on:touchend="moveBoxesFinish"
            >
                <div class="my-plan__box__controls">
                    <a class="my-plan__box__control my-plan__box__control--prev"
                       v-bind:class="{ 'is-disabled' : boxControl.isDisabled.prev }"
                       v-on:click="moveBoxesLeft"
                    >
                        Previous
                    </a>
                    <a class="my-plan__box__control my-plan__box__control--next"
                       v-bind:class="{ 'is-disabled' : boxControl.isDisabled.next }"
                       v-on:click="moveBoxesRight"
                    >
                        Next
                    </a>
                </div>

                <div class="my-plan__boxes">
                    <div class="my-plan__box" v-bind:class="'my-plan__box--' + box.key" v-for="(box, key) in boxes">
                        <h4 class="my-plan__box__title" v-html="box.heading"></h4>

                        <div class="my-plan__box__text"
                             v-html="box.text"
                             v-if="box.text !== ''"
                        ></div>

                        <ul class="my-plan__box__list"
                            v-if="box.links.length > 0 && box.links[0]"
                        >
                            <li v-bind:class="{ 'is-checked' : userListChecktable[link] }"
                                v-if="link && (key < 4 || box.open) && box.linkLabels[key]"
                                v-for="(link, key) in box.links"
                            >
                                <span v-on:click="updateUserLinks(box.heading, link, box.linkLabels[key])"></span>
                                <a v-bind:href="link"
                                   v-html="box.linkLabels[key]"
                                ></a>
                            </li>
                        </ul>

                        <a class="my-plan__box__list__more"
                           v-if="box.links.length > 4 && !box.open"
                           v-on:click="openBoxList(key)"
                        >
                            Show more
                        </a>
                    </div>
                </div>

                <div class="my-plan__box__bullets">
                    <span class="my-plan__box__bullet"
                          v-bind:class="{ 'is-active' : bullet === boxControl.current + 1 }"
                          v-for="bullet in boxControl.items"
                    >{{ bullet }}</span>
                </div>
            </div>

            <div class="my-plan__text is-hidden-desktop"
                 v-html="page.my_plan.text"
                 v-if="page.my_plan.text !== ''"
            ></div>

            <a class="my-plan__btn is-hidden-desktop is-left-aligned is-main is-red"
               v-bind:href="page.my_plan.my_plan_button_link"
               v-html="page.my_plan.my_plan_button_label"
            ></a>
        </div>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        computed: {
            answerSequenceLength: function () {
                return this.answerSequence !== 'X'.repeat(this.totalQuestions)
                    ? this.answerSequence.length
                    : 0
            },
            completed: function () {
                return Math.round((this.currentQuestion + 1) / this.totalQuestions * 100);
            },
        },
        created: function () {
            this.backgroundStyle = document.querySelector('body').style.backgroundImage;

            this.findStartScreen();
        },
        data: function () {
            return {
                answerSequence: '',
                currentQuestion: null,
                currentScreen: 'welcome',
                backgroundStyle: null,
                boxControl: {
                    current: 0,
                    el: null,
                    isDisabled: {
                        next: false,
                        prev: true,
                    },
                    items: 8,
                    itemMargin: null,
                    itemWidth: null,
                    maxOffset: null,
                    x0: 0
                },
                boxes: [],
                result: null,
                totalQuestions: this.page.questions.length,
                userListChecktable: []
            }
        },
        methods: {
            addUrlFragment: function () {
                let fragment = null;

                switch (this.currentScreen) {
                    case 'welcome':
                        fragment = 'welcome';

                        break;
                    case 'question':
                        fragment = this.page.questions[this.currentQuestion].question_heading.urlify();

                        break;
                    case 'end':
                        fragment = 'end';

                        break;
                }

                history.pushState(
                    '',
                    document.title,
                    fragment ? window.location.pathname + '#' + fragment : window.location.pathname
                );
            },
            findStartScreen: function () {
                this.answerSequence = this.user.my_plan_sequence
                    ? this.user.my_plan_sequence
                    : '';

                if (this.answerSequence !== '' && this.answerSequence !== 'X'.repeat(this.totalQuestions)) {
                    this.gotoScreen('my-plan');
                }
            },
            gotoScreen: function (screen, question = null, back = false) {
                // push GTM codes before changing screens
                if (!back) {
                    this.pushGtmStages();
                }

                // fill up skipped answers with X
                let fillUpto = question ? question : this.totalQuestions;
                while (this.answerSequence.length < fillUpto) {
                    this.answerSequence += 'X';
                }

                // jump to screen
                this.currentScreen = screen;
                if (screen === 'question' && question !== null) {
                    this.currentQuestion = question;
                } else {
                    this.currentQuestion = null;
                }

                // screen specific actions
                if (screen === 'my-plan') {
                    this.initBoxControl();
                    this.initUserListChecktable();
                    this.updateUserSequence();

                    document.querySelector('body').style.backgroundImage = null;
                } else {
                    document.querySelector('body').style.backgroundImage = this.backgroundStyle;
                }

                // add url fragment
                this.addUrlFragment();
            },
            initBoxControl: function () {
                this.$nextTick(() => {
                    const firstBox = document.querySelector('.my-plan__box:first-child');

                    this.boxControl.el = document.querySelector('.my-plan__boxes');
                    this.boxControl.el.style.marginLeft = '0px';
                    this.boxControl.itemMargin = parseInt(
                        window.getComputedStyle(firstBox).marginRight.replace(/\D/g, '')
                    );
                    this.boxControl.itemWidth = firstBox.offsetWidth;
                    this.boxControl.maxOffset = (
                        this.boxControl.el.parentNode.offsetWidth
                        - this.boxControl.items * (this.boxControl.itemMargin + this.boxControl.itemWidth)
                        - 30
                    );
                });
            },
            initBoxes: function () {
                this.boxes = [
                    {
                        heading: this.page.my_plan.box_1_heading,
                        key: 'box-1',
                        links: this.page.my_plan.box_1_links,
                        linkLabels: this.page.my_plan.box_1_link_labels,
                        open: false,
                        order: this.page.my_plan.box_1_order,
                        text: this.page.my_plan.box_1_text
                    },
                    {
                        heading: this.page.my_plan.box_2_heading,
                        key: 'box-2',
                        links: this.page.my_plan.box_2_links,
                        linkLabels: this.page.my_plan.box_2_link_labels,
                        open: false,
                        order: this.page.my_plan.box_2_order,
                        text: this.page.my_plan.box_2_text
                    },
                    {
                        heading: this.page.my_plan.box_3_heading,
                        key: 'box-3',
                        links: this.page.my_plan.box_3_links,
                        linkLabels: this.page.my_plan.box_3_link_labels,
                        open: false,
                        order: this.page.my_plan.box_3_order,
                        text: this.page.my_plan.box_3_text
                    },
                    {
                        heading: this.page.my_plan.box_4_heading,
                        key: 'box-4',
                        links: this.page.my_plan.box_4_links,
                        linkLabels: this.page.my_plan.box_4_link_labels,
                        open: false,
                        order: this.page.my_plan.box_4_order,
                        text: this.page.my_plan.box_4_text
                    },
                    {
                        heading: this.page.my_plan.box_5_heading,
                        key: 'box-5',
                        links: this.page.my_plan.box_5_links,
                        linkLabels: this.page.my_plan.box_5_link_labels,
                        open: false,
                        order: this.page.my_plan.box_5_order,
                        text: this.page.my_plan.box_5_text
                    },
                    {
                        heading: this.page.my_plan.box_6_heading,
                        key: 'box-6',
                        links: this.page.my_plan.box_6_links,
                        linkLabels: this.page.my_plan.box_6_link_labels,
                        open: false,
                        order: this.page.my_plan.box_6_order,
                        text: this.page.my_plan.box_6_text
                    },
                    {
                        heading: this.result.flexbox_1_heading,
                        key: 'flexbox-1',
                        links: this.result.flexbox_1_links,
                        linkLabels: this.result.flexbox_1_link_labels,
                        open: false,
                        order: this.result.flexbox_1_order,
                        text: this.result.flexbox_1_text
                    },
                    {
                        heading: this.result.flexbox_2_heading,
                        key: 'flexbox-2',
                        links: this.result.flexbox_2_links,
                        linkLabels: this.result.flexbox_2_link_labels,
                        open: false,
                        order: this.result.flexbox_2_order,
                        text: this.result.flexbox_2_text
                    }
                ];

                // order boxes
                this.boxes.sort((a, b) => {
                    return parseInt(a.order) - parseInt(b.order);
                });
            },
            initUserListChecktable: function () {
                this.user.links.forEach((link) => {
                    this.userListChecktable[link] = 1;
                });
            },
            moveBoxesFinish: function (event) {
                const dx = this.unifyEvent(event).clientX - this.boxControl.x0;
                const sensitivity = 20;

                if (dx < sensitivity * -1) {
                    this.moveBoxesRight();
                } else if (dx > sensitivity) {
                    this.moveBoxesLeft();
                }

                // enable scrolling
                document.body.style.overflowY = '';
            },
            moveBoxesLeft: function () {
                if (this.boxControl.isDisabled.prev) {
                    return;
                }

                this.boxControl.current--;
                this.boxControl.isDisabled.next = false;

                let offset = this.boxControl.current * (this.boxControl.itemMargin + this.boxControl.itemWidth) * -1;

                if (offset < 0) {
                    this.boxControl.el.style.marginLeft = offset + 'px';

                    this.boxControl.isDisabled.prev = false;
                } else {
                    this.boxControl.el.style.marginLeft = '0px';

                    this.boxControl.isDisabled.prev = true;
                }
            },
            moveBoxesRight: function () {
                if (this.boxControl.isDisabled.next) {
                    return;
                }

                this.boxControl.current++;
                this.boxControl.isDisabled.prev = false;

                let offset = this.boxControl.current * (this.boxControl.itemMargin + this.boxControl.itemWidth) * -1;

                if (offset > this.boxControl.maxOffset) {
                    this.boxControl.el.style.marginLeft = offset + 'px';

                    this.boxControl.isDisabled.next = false;
                } else {
                    this.boxControl.el.style.marginLeft = this.boxControl.maxOffset + 'px';

                    this.boxControl.isDisabled.next = true;
                }
            },
            moveBoxesStart: function (event) {
                this.boxControl.x0 = this.unifyEvent(event).clientX;

                // disable scrolling
                document.body.style.overflowY = 'hidden';
            },
            nextQuestion: function (key) {
                if (key === this.totalQuestions - 1) {
                    return null;
                }

                // skip logic
                switch (key) {
                    case 0:
                        return this.answerSequence.charAt(key) === 'A' ? 1 : null;
                    case 1:
                        return this.answerSequence.charAt(key) === 'A' ? 2 : 3;
                    case 2:
                        return 3;
                    case 3:
                        return this.answerSequence.charAt(key) === 'A' ? 4 : null;
                    default:
                        return null;
                }
            },
            openBoxList: function(key) {
                this.boxes[key].open = true;
            },
            previousQuestion: function (key) {
                if (key === 0) {
                    return null;
                }

                // reverse skip logic
                switch (key) {
                    case 1:
                        return 0;
                    case 2:
                        return 1;
                    case 3:
                        return this.answerSequence.charAt(1) === 'A' ? 2 : 1;
                    case 4:
                        return 3;
                    case 99:
                        return this.answerSequence.charAt(0) === 'A'
                            ? this.answerSequence.charAt(3) === 'A' ? 4 : 3
                            : 0;
                    default:
                        return null;
                }
            },
            pushGtmStages: function () {
                if (!window.dataLayer) {
                    return;
                }

                let stageId = null;
                let stageName = null;
                let stageChoice = null;

                switch (this.currentScreen) {
                    case 'welcome':
                        stageId = 0;
                        stageName = 'welcome';
                        stageChoice = this.page.welcome.welcome_button_label.urlify('_');

                        break;
                    case 'question':
                        stageId = this.currentQuestion + 1;
                        stageName = this.page.questions[this.currentQuestion].question_heading.urlify('_');

                        const answer = this.answerSequence.charCodeAt(this.currentQuestion) - 65;
                        stageChoice = this.page.questions[this.currentQuestion].answers[answer].urlify('_');

                        break;
                    case 'end':
                        stageId = 99;
                        stageName = 'end';

                        stageChoice = '0_welcome_' + this.page.welcome.welcome_button_label.urlify('_');
                        for (let i = 0; i < this.totalQuestions; i++) {
                            if (this.answerSequence[i] === 'X') {
                                continue;
                            }

                            let answer = this.answerSequence.charCodeAt(i) - 65;
                            stageChoice +=
                                ' | ' + (i + 1) + '_'
                                + this.page.questions[i].question_heading.urlify('_') + '_'
                                + this.page.questions[i].answers[answer].urlify('_');
                        }

                        break;
                }

                if (stageId && stageName && stageChoice) {
                    window.dataLayer.push({
                        'event': 'wizard',
                        'wizard': {
                            'stage': {
                                'id': stageId,
                                'name': stageName,
                                'choice': stageChoice,
                            }
                        }
                    });
                }
            },
            pushGtmUserLink: function (box, link, action) {
                if (!window.dataLayer) {
                    return;
                }

                window.dataLayer.push({
                    'event': 'planChoice',
                    'planItem': box.urlify('_') + '-' + link.urlify('_') + '-' + action
                });
            },
            refreshPlan: function () {
                this.gotoScreen('welcome');
            },
            setAnswer: function (question, letter) {
                // do nothing if answer didn't change
                if (this.answerSequence.charAt(question) === String.fromCharCode(letter + 65)) {
                    return;
                }

                // add answer letter to answer sequence
                if (this.answerSequence.length <= question) {
                    this.answerSequence += String.fromCharCode(letter + 65);
                } else {
                    this.answerSequence = this.answerSequence.substr(0, question) + String.fromCharCode(letter + 65) + this.answerSequence.substr(question + 1)
                }

                // remove answer letter from sequence for subsequent questions
                this.answerSequence = this.answerSequence.substring(0, question + 1);
            },
            skipQuestions: function () {
                eventBus.$emit('show-loader');

                if (this.user.my_plan_sequence === null) {
                    this.$http.put('/api/users/' + this.user.id, {
                        my_plan_sequence: 'X'.repeat(this.totalQuestions),
                        my_plan_updated_on: new Date().toUTCString()
                    }).then(function(response) {
                        eventBus.$emit('hide-loader');

                        window.location.href = '/guides';
                    }, function (response) {
                        console.error('ERROR: there was an error updating user.');

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': 'error',
                                'error': 'There was an error updating user.'
                            });
                        }

                        eventBus.$emit('hide-loader');

                        window.location.href = '/guides';
                    });
                } else {
                    window.location.href = '/guides';
                }
            },
            updateUserLinks: function (box, link, linkLabel) {
                eventBus.$emit('show-loader');

                if (!(link in this.userListChecktable) || this.userListChecktable[link] === 0) {
                    this.userListChecktable[link] = 1;

                    this.$http.put('/api/users/' + this.user.id + '/links', {
                        link: link
                    }).then(function(response) {
                        eventBus.$emit('hide-loader');
                    }, function(response) {
                        console.error('ERROR: there was an error updating user.');

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': 'error',
                                'error': 'There was an error updating user.'
                            });
                        }

                        eventBus.$emit('hide-loader');
                    });

                    this.pushGtmUserLink(box, linkLabel, 'tick');
                } else {
                    this.userListChecktable[link] = 0;

                    this.$http.delete('/api/users/' + this.user.id + '/links', {
                        body: {
                            link: link
                        }
                    }).then(function(response) {
                        eventBus.$emit('hide-loader');
                    }, function(response) {
                        console.error('ERROR: there was an error updating user.');

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': 'error',
                                'error': 'There was an error updating user.'
                            });
                        }

                        eventBus.$emit('hide-loader');
                    });

                    this.pushGtmUserLink(box, linkLabel, 'untick');
                }
            },
            updateUserSequence: function () {
                eventBus.$emit('show-loader');

                this.$http.put('/api/users/' + this.user.id, {
                    my_plan_sequence: this.answerSequence,
                    my_plan_updated_on: new Date().toUTCString()
                }).then(function(response) {
                    eventBus.$emit('hide-loader');
                }, function(response) {
                    console.error('ERROR: there was an error updating user.');

                    if (window.dataLayer) {
                        window.dataLayer.push({
                            'event': 'error',
                            'error': 'There was an error updating user.'
                        });
                    }

                    eventBus.$emit('hide-loader');
                });
            },
            unifyEvent: function (event) {
                return event.changedTouches ? event.changedTouches[0] : event;
            }
        },
        props: {
            page: {
                required: true,
                type: Object
            }
        },
        watch: {
            answerSequence: function () {
                let result = null;

                this.page.logic.forEach(function (logic) {
                    if (logic.logic_key === this.answerSequence) {
                        result = logic;
                    }
                }.bind(this));

                this.result = result;

                if (result) {
                    this.initBoxes();
                }
            }
        }
    }
</script>
